import {NgModule} from '@angular/core'
import {FormsModule} from '@angular/forms'
import {CommonModule} from '@angular/common'

/**
 * Инициализация Ant-Design
 */
import {NzModule} from '../../nz.module'
import {MlVsService} from './ml.vs.service'
import {MlVendorSearchComponent} from './ml-vendor.search.component'
import {VendorIconModule} from '../vendor-icon/vendor-icon.module'
import {RouterModule} from '@angular/router'
import {PipesModule} from '../../pipes.module'

@NgModule({
  declarations: [
    // components
    MlVendorSearchComponent
  ],
    imports: [
        // Modules
        CommonModule,
        NzModule,
        FormsModule,
        VendorIconModule,
        RouterModule,
        PipesModule
    ],
  exports: [
    MlVendorSearchComponent,
    // modules
  ],
  providers: [
    // services
    MlVsService
  ]
})

export class MlVsModule {
  constructor() {}
}
